export type RuntimeMode = "telegram_mini_app" | "standalone_web";

export type TelegramWebApp = {
  initData?: string;
  colorScheme?: "light" | "dark";
  themeParams?: Record<string, string>;
  ready?: () => void;
  expand?: () => void;
  close?: () => void;
  HapticFeedback?: {
    impactOccurred?: (style: "light" | "medium" | "heavy") => void;
    notificationOccurred?: (type: "success" | "warning" | "error") => void;
  };
  BackButton?: {
    show: () => void;
    hide: () => void;
    onClick: (handler: () => void) => void;
  };
};

declare global {
  interface Window {
    Telegram?: {
      WebApp?: TelegramWebApp;
    };
  }
}

export function detectRuntime(): RuntimeMode {
  return window.Telegram?.WebApp?.initData ? "telegram_mini_app" : "standalone_web";
}

export function getTelegramWebApp(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

export function getTelegramInitData(): string | undefined {
  return getTelegramWebApp()?.initData;
}

export function getAuthHeaders(): HeadersInit {
  const initData = getTelegramWebApp()?.initData;
  if (initData) {
    return { "X-Telegram-Init-Data": initData };
  }
  const devTelegramId = import.meta.env.VITE_DEV_TELEGRAM_ID as string | undefined;
  if (devTelegramId) {
    return { "X-Znich-Dev-Telegram-Id": devTelegramId };
  }
  return {};
}
